export default "__VITE_ASSET__BRA3jJs4__"